import React, { useCallback } from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { Icon } from 'js/components/common/Icon';
import { Button } from 'js/components/common/Button';
import buildClassName from 'js/utils/classNameBuilder.util';

import * as hooks from './hooks';

import style from './ExportButton.scss';

export const ExportButton = (props) => {
    const { btnText, loadingText, onClick, isDisabled, isLoading, classNames } = props;
    const translate = useTranslations();
    const downloadCSV = hooks.useDownloadCSV();
    const wrappedOnClick = useCallback(() => onClick(downloadCSV), [onClick, downloadCSV]);
    const loadingClass = isLoading ? 'loading' : '';

    return (
        <Button
            type="button"
            view="primary"
            disabled={isDisabled}
            onClick={wrappedOnClick}
            className={buildClassName(['exportBtn', loadingClass], style, classNames)}
        >
            {isLoading
                ? loadingText || translate('playtech.mobile.system.export.button.loading')
                : (
                    <>
                        <Icon type="export" className={buildClassName(['exportBtnIcon'], style, classNames)} />
                        {btnText || translate('playtech.mobile.system.export.button.title')}
                    </>
                )
            }
        </Button>
    );
};
